import { LmsHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const PutEnrollmentData = (obj, state, setState) => {
  if (state.isSaving !== true && !state.message) {
    let newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Saving...'
    };
    setState(newState);

    const url = '/Enrollment';
    LmsHttpHelper(url, 'PUT', obj)
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isSaving: false,
            isSaved: true,
            isObjLoaded: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isSaving: false,
          isSaved: false,
          isObjLoaded: false,
          message: message
        });
      });
  };
};

export default PutEnrollmentData;